import { pick } from 'lodash'
import { track } from './analytics'

export const GDPRBetaRequested = args => {
  track('GDPR Beta Requested', pick(args, ['workspaceSlug']))
}
